<template>
  <div>
    <!-- Page content -->
    <b-container class="mt--8 pb-5">
      <!-- Table -->
      <b-row class="justify-content-center">
        <b-col>
          <card>
            <b-row align-v="center" slot="header">
              <b-col cols="8">
                <h3 class="mb-0">Cadastro de Categoria de Peça Publicitária</h3>
              </b-col>
              <b-col cols="4" v-loading="loading" />
            </b-row>

            <b-form @submit.prevent="save" v-loading="loading">
              <!-- Dados de Acesso -->
              <h6 class="heading-small text-muted mb-4">Dados da Categoria</h6>
              <div class="pl-lg-4">
                <b-row>
                  <b-col lg="8">
                    <base-input
                      type="text"
                      label="Nome"
                      name="Nome"
                      placeholder="Digite o nome da categoria"
                      v-model="data.nome"
                    >
                    </base-input>
                  </b-col>

                  <b-col lg="4">
                    <base-input
                      type="text"
                      label="Posição (número)"
                      name="Posição"
                      placeholder="Digite a posição da categoria (ex: 1, 2, 15)"
                      v-model="data.posicao"
                    >
                    </base-input>
                  </b-col>
                </b-row>
                <b-row>
                  <b-col lg="8">
                    <base-input
                      type="text"
                      label="Senha"
                      name="Senha"
                      placeholder="Digite a senha da categoria"
                      v-model="data.senha"
                    >
                    </base-input>
                  </b-col>
                  <b-col lg="4">
                    <base-input name="Ativo" label="Ativo?">
                      <b-form-checkbox v-model="data.ativo">
                        <span class="text-muted">Ativo</span>
                      </b-form-checkbox>
                    </base-input>
                  </b-col>
                </b-row>
              </div>

              <hr class="my-4" />
              <div
                class="pl-lg-4 d-flex justify-content-end align-items-center"
              >
                <span class="text-danger mr-3">{{ errorFeedback }}</span>
                <base-button
                  type="primary"
                  native-type="submit"
                  :loading="loading"
                  class="my-4"
                >
                  <span v-if="!idEdit">Cadastrar</span>
                  <span v-else>Salvar</span>
                </base-button>
              </div>
            </b-form>
          </card>
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>
<script>
import api from "@/services/api";

export default {
  name: "categoria-peca-publicitaria-form",
  data() {
    return {
      errorFeedback: "",
      loading: false,
      idEdit: null,
      data: {
        id: "",
        ativo: true,
        nome: "",
        posicao: "0",
        senha: "",
      },
    };
  },
  methods: {
    async save() {
      this.errorFeedback = "";
      this.loading = true;
      try {
        await api.post("/categoria-peca-publicitaria", this.data);
        this.$router.push("/login");
      } catch (e) {
        this.errorFeedback =
          "Ocorreu um problema. Por favor, tente novamente mais tarde.";
      } finally {
        this.loading = false;
      }
    },
  },
  async mounted() {
    this.idEdit = this.$route.params.id;
    if (this.idEdit) {
      this.loading = true;
      try {
        const response = await api.get(
          `/categoria-peca-publicitaria/${this.idEdit}`
        );
        this.data = response.data;
      } catch (e) {
        this.$swal(
          "Oops!",
          "Ocorreu um problema ao carregar os dados. Por favor, tente novamente mais tarde."
        );
      } finally {
        this.loading = false;
      }
    }
  },
};
</script>
<style></style>
